import { Empty } from 'antd';
import { fromAppVar } from 'graphql/cache';

import './EmptyProposal.scss';

const EmptyProposal = ({ status }) => {
  const fromApp = fromAppVar();
  const description =
    fromApp === 'hubspot'
      ? 'You don’t have permission to view this proposal. You can ask the creator to share it with you.'
      : `Proposal ${status === 'expired' ? 'Expired' : 'Not Found'}`;
  return <Empty className="empty-proposal" description={<span> {description}</span>} />;
};

export default EmptyProposal;
